// removed by extract-text-webpack-plugin
module.exports = {"component":"_2cqKHRFVYh_Cm7TAY8RCAA","cta":"_2HHCzw2t49x-nUrso0nY8q","primary":"WKZckH1i7RuxYFjjkoiEQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordActions/HealthRecordActions.css
// module id = 1263
// module chunks = 0